import axios from "axios";
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: 30000,
});
axiosInstance.interceptors.response.use(
  function (response) {
    if (
      response?.data?.data?.status_code === 403 ||
      response?.data?.data?.status_code === 401
    ) {
      localStorage.removeItem("banimodeUserProd");
      localStorage.removeItem("banimodeUserdev");
      window.location.reload();
    }
    return response;
  },
  function (error) {
    if (
      (error.response && error.response?.status === 403) ||
      error.response?.status === 401
    ) {
      localStorage.removeItem("banimodeUserProd");
      localStorage.removeItem("banimodeUserdev");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
